import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "bg-white p-3 shadow-md rounded-md" }
const _hoisted_2 = { class: "font-bold py-2" }
const _hoisted_3 = { class: "font-bold" }
const _hoisted_4 = ["innerHTML"]
const _hoisted_5 = {
  key: 0,
  class: "border border-h-success-200 p-4 flex flex-col gap-3 bg-h-neutral-100 mt-4 rounded-sm"
}
const _hoisted_6 = { class: "flex flex-row items-center gap-3" }
const _hoisted_7 = {
  key: 0,
  class: "border border-h-error-100 p-4 flex flex-col gap-3 bg-h-neutral-100 mt-4 rounded-sm"
}
const _hoisted_8 = { class: "flex flex-row items-center gap-3" }
const _hoisted_9 = { class: "flex flex-row items-center gap-2" }
const _hoisted_10 = { class: "font-bold" }
const _hoisted_11 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_icon = _resolveComponent("v-icon")!

  return (_openBlock(), _createElementBlock("article", _hoisted_1, [
    _createElementVNode("p", _hoisted_2, _toDisplayString(_ctx.answer.question?.prompt), 1),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.processedItems, (item, index) => {
      return (_openBlock(), _createElementBlock("div", {
        key: item,
        class: "flex flex-row items-center gap-2"
      }, [
        _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.getAnswerLabel(index)), 1),
        _createElementVNode("span", {
          innerHTML: item.answerText,
          class: "item-answer"
        }, null, 8, _hoisted_4)
      ]))
    }), 128)),
    (_ctx.correctedItems.length === 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createVNode(_component_v_icon, {
              name: "hi-solid-check-circle",
              scale: 1.3,
              class: "text-h-success-700"
            }, null, 8, ["scale"]),
            _createElementVNode("span", null, _toDisplayString(_ctx.$t("labels.generic", {
            pt: "Resposta correta",
            en: "Correct response",
          })), 1)
          ])
        ]))
      : _createCommentVNode("", true),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.correctedItems, (item) => {
      return (_openBlock(), _createElementBlock("div", {
        key: item.text
      }, [
        (item.correctedItem.has)
          ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, [
                _createVNode(_component_v_icon, {
                  name: "hi-solid-x-circle",
                  scale: 1.3,
                  class: "text-red-700"
                }, null, 8, ["scale"]),
                _createElementVNode("span", null, _toDisplayString(_ctx.$t("labels.generic", {
              pt: "Resposta incorreta",
              en: "Incorrect responses",
            })), 1)
              ]),
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("span", _hoisted_10, _toDisplayString(_ctx.getAnswerLabel(item.correctedItem.index)), 1),
                _createElementVNode("span", {
                  innerHTML: item.text
                }, null, 8, _hoisted_11)
              ])
            ]))
          : _createCommentVNode("", true)
      ]))
    }), 128))
  ]))
}